import { useContext, useEffect, useState } from 'react';
import { Subscription } from 'rxjs';

import { SocketContext } from '../providers/SocketProvider/SocketProvider';
import { Game } from '../services/backendService/types';
import { newRelicNoticeError } from './useNewRelic';

function useGameListener(gameId: string, tenantId: string) {
  const { gameAPI } = useContext(SocketContext);
  const [game, setGame] = useState<Game>();

  useEffect(() => {
    let $sub: Subscription | undefined = undefined;
    if (tenantId && gameId && gameAPI) {
      $sub = gameAPI.game.onChange({ gameId, tenantId }).subscribe({
        next: val => {
          setGame(val);
        },
        error: error => {
          newRelicNoticeError(error, 'Error while listening to game changes');
        },
      });
    }
    return () => {
      if ($sub) {
        $sub.unsubscribe();
      }
    };
  }, [tenantId, gameId, gameAPI]);

  return {
    game,
  };
}

export default useGameListener;
